import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { getDetailSession, seniorDeclineOrAcceptSuccessTopic } from 'redux/actions/mvp/session.action';
import './detail.scss'
import moment from "moment/moment";
import 'react-toastify/dist/ReactToastify.css';
import '@zoom/videosdk-ui-toolkit/dist/videosdk-ui-toolkit.css'
import { I18n } from '../../../../helpers/i18n';

function DeclineSession({
   match,
   getDetailSession,
   seniorDeclineOrAcceptSuccessTopic,
}) {
    const sessionId = match.params.id;
    const scrollRef = useRef(null);
    const [message, setMessage] = useState(null);
    // senior
    useEffect( async () => {
      document.title = `TECD - ${I18n.t('tecd_slogan')}`;
      async function actionData() {
        if (!sessionId) return;
        const dataAction = await seniorDeclineOrAcceptSuccessTopic({
          sessionId: sessionId,
          action: 'decline'
        })
        console.log('dataAction', dataAction)
        setMessage(dataAction.message)
      }

      actionData()
    }, [seniorDeclineOrAcceptSuccessTopic, setMessage])

    return (
        <div id="site_wrapper">
            <main className="main" ref={scrollRef}>
                <div className="container">
                  <p style={{ color: '#FFFFFF' }}>{ message }</p>
                </div>
            </main>
        </div>
    )
}

const mapStateToProps = ({ user, mvp }) => ({
    user, mvp
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
      getDetailSession,
      seniorDeclineOrAcceptSuccessTopic
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DeclineSession);
